(function () {
  const Core = window.RB.Core;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Lux, Crownguard": {
      abilities: [{
        label: "Add 2 energy (spells only)",
        exhausts: true, reaction: true, isAdd: true,
        program: [{ op: "addResources", res: { energy: 2 } }],
      }],
    },

    "Vanguard Attendant": { entersReady: true },

    "Recruit the Vanguard": {
      play: [
        { op: "chooseDest", varKey: "rv", prompt: "Play 4 Recruit tokens where?" },
        { op: "token", name: "Recruit", n: 4, locVar: "rv" },
      ],
    },

    "Garen, Commander": {
      auraMightSpecs: [{ n: 1, scope: "here", excludeSelf: true }],
    },

    "Blast of Power": {
      play: [{ op: "kill", to: "$t1" }],
      targets: [{ bind: "t1", spec: { type: "unit", atBf: true }, prompt: "Kill..." }],
    },
  });
})();
